export default class ErrorModel{
  ErrorCode: number;
  ErrorMessage: string;
  constructor(obj?: Partial<ErrorModel>) {
    if (obj) {
      Object.assign(this, obj)
    }
  }
}
